import { msg } from "@lingui/core/macro";
import { createRoute } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { AuthPlaceholder } from "@/components/auth-placeholder";
import { PageContainer } from "@fleet/ui/page-container";
import { MeetingsPage } from "@/features/domain/components/meetings-page";
import { useI18n } from "@/providers/i18n-provider";

function MeetingsRoutePage() {
  const { t } = useI18n();
  return (
    <AuthPlaceholder
      title={t(msg`Meetings`)}
      description={t(msg`Sign in to see and organize meetings.`)}
    >
      <PageContainer maxWidth="3xl">
        <MeetingsPage />
      </PageContainer>
    </AuthPlaceholder>
  );
}

export const meetingsRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/meetings",
  component: MeetingsRoutePage,
});
